module.exports = __webpack_public_path__ + "img/it.22b99ae7.svg";